import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router';

/** Inquiry id from inquiry detail/edit or offer routes (`id` or `inquiryId` param). */
export function useLlmChatInquiryScope(): string | null {
  const { pathname } = useLocation();
  const params = useParams<{ id?: string; inquiryId?: string }>();

  return useMemo(() => {
    if (pathname === '/inquiries/new') return null;
    const match = pathname.match(/^\/inquiries\/([^/]+)/);
    if (!match) return null;
    return params.inquiryId ?? params.id ?? match[1] ?? null;
  }, [pathname, params.inquiryId, params.id]);
}

export function isInquiryOfferRoute(pathname: string): boolean {
  return /\/inquiries\/[^/]+\/offers(?:\/|$)/.test(pathname);
}
